import { Link } from 'react-router-dom'
import {  useAuth } from '../context/AuthProvider';
import welcome_pre_login from "../assets/welcome_pre_login.png";

export default function CardGetStarted() {
  const { user } = useAuth()

  return (
    <div className="flex  mx-auto px-4 md:px-6 lg:px-8 flex-col md:flex-row items-center py-10">
    <div className="md:w-1/2 text-center mb-14 md:mb-0">
      <h2 className="text-2xl font-bold md:text-3xl lg:text-4xl bg-clip-text bg-gradient-to-r from-cyan-600 to-fuchsia-700 text-transparent">
        A FONOAUDIOLOGIA NA PALMA DA SUA MÃO
      </h2>
      <Link to={`${!user ? "/cadastro" : "/meuplano"}`} className="py-3 mt-4 px-6 inline-flex items-center gap-x-2 text-sm font-semibold rounded-xl border border-transparent bg-pink-600 text-white hover:bg-primary disabled:opacity-50 disabled:pointer-events-none">
        {!user ? "Cadastre-se" : "Baixe nosso app"}
      </Link>
    </div>

    <div className="md:w-1/2 flex justify-center">
      <img className=" w-full md:w-96 h-auto object-contain" src={welcome_pre_login} alt="description" />
    </div>
  </div>

  )
}
